<template>
	<div>
		<div class="field-wrapper-global d-flex align-items-center">
			<p class="mb-0 mr-2">{{$t('chEn_entity')}} </p>
			<select class="float-field-global"  @change="onChange()" v-model="onchangeData"> 
				<option value="G">{{$t('chEn_global')}}</option>
				<option value="E">{{$t('chEn_europe')}}</option>
			</select>
		</div>
		
		<!-- <div class="modal-popup LoginPopup" v-if="popupScreen">
			<div class="middleBox p-3 whiteBG">
				<p class="text-center" style="font-size: 13px;">
					{{$t('chEn_redirectmsg1')}}

					{{$t('chEn_redirectmsg2')}}
				</p>
				<div class="w-100 d-flex justify-content-center align-items-center">
					<a href="#" @click.prevent="popupScreen = false ;Entity = 'G' ; onChange()" class="prism_btn btn_sm mr-3">{{$t('chEn_continue')}}</a>
					<a href="#" @click.prevent="popupScreen = false ; onchangeData = 'E'" class="prism_btn btn_sm darkBG">{{$t('chEn_takeback')}}</a>
				</div>
			</div>
		</div> -->
	</div>
</template>
<script>
	import { Const } from '@/plugins/fxView/provider/candle-history/lib/const.cls.ts'
     export default {
        name: 'Login',
        data() {
            return {
            	onchangeData : 'G',
              	Entity : 'G',
               	popupScreen : false
            }
        },
        methods:{
            onChange(){
            	if(this.onchangeData == 'E'){
            		window.open('https://app.fxview.com/', "_self"); 
            	}
            	// if(this.onchangeData == 'G' && this.Entity != 'G'){
            	// 	this.popupScreen = true
            	// }else{
            		// this.Entity = this.onchangeData
        			// localStorage.setItem('entity',this.Entity)
        			// this.$store.commit(Const.SET_ENTITY_DATA,  this.Entity)
            	// }
        	},
        },
		created(){
			// if(localStorage.getItem('entity')){
			// 	this.onchangeData = localStorage.getItem('entity')
			// 	this.Entity = localStorage.getItem('entity')
			// 	this.$store.commit(Const.SET_ENTITY_DATA,  this.Entity)
			// }
			// this.onChange()
		}
    }
</script>	
		



// WEBPACK FOOTER //
// src/components/fxView/shared/change_entity.vue